// //DAFI
// export const STAKING_DATABASE_ETH_MAINNET_V2 =
//   "0x3320c38193F4c7Ae9bBd9B545de1234AecC9E8E3";

// export const STAKING_DATABASE_POLYGON_MAINNET =
//   "0x3320c38193F4c7Ae9bBd9B545de1234AecC9E8E3";

// export const STAKING_DATABASE_BINANCE_MAINNET =
//   "0xD6Bd7690929610E63e1F53f89A6dBddAb79AE9fE";

// // NITRO
// export const NITRO_STAKING_DATABASE_ETHEREUM_MAINNET =
//   "0xDd0fE322E6f402642Afd951064c3a592b6c31993";

// export const NITRO_STAKING_DATABASE_POLYGON_MAINNET =
//   "0x229A79c7a77cF342a0C7cc8158D9f00a41Df24dD";

// // PGEN
// export const PGEN_STAKING_DATABASE_POLYGON_MAINNET =
//   "0x5e80F3E01b3A5e61E481F9b81E17FA697727C757";

// //MIMIR
// export const MIMIR_STAKING_DATABASE_ETHEREUM_MAINNET =
//   "0xd2e352735540e3af4B1b4AED3F00df45b62f0Eb8";

// export const MIMIR_STAKING_DATABASE_POLYGON_MAINNET =
//   "0xFfd1cD8f989F7563363AeE8D32902c16c7DDa01D";

// export const MIMIR_STAKING_DATABASE_BINANCE_MAINNET =
//   "0x3B5EA4aa9ff718441f469f0b84AdC804eAB273DF";

// // POLI
// export const POLI_STAKING_DATABASE_POLYGON_MAINNET =
//   "0xc68350d6bC933A5aa50eb50e95611B551B1783F6";

// export const POLI_STAKING_DATABASE_ETHEREUM_MAINNET =
//   "0x54CB8e9d82E59c505E0e001Bc599388a0019FC3C";

// // QUIDD
// export const QUIDD_STAKING_DATABASE_BINANCE_MAINNET =
//   "0xE31015F60fD4797Cd221999e484763A238dCbCe2";

// export const QUIDD_DIST_POOL_BINANCE_MAINNET =
//   "0x7961ade0a767c0e5b67dd1a1f78ba44f727642ed";

export const ContractAddresses = {
  dafi: {
    2: {
      stakingDatabase: "0x3320c38193F4c7Ae9bBd9B545de1234AecC9E8E3",
      token: "0xFc979087305A826c2B2a0056cFAbA50aad3E6439",
      distPool: "0xC7Aa64E8434d212764b9694C7bF8B32e7360C640",
    },
    3: {
      stakingDatabase: "0x3320c38193F4c7Ae9bBd9B545de1234AecC9E8E3",
      token: "0x638Df98Ad8069a15569dA5a6b01181804c47e34c",
      distPool: "0xbc8318b9ebB4e3770f2D729537eBE7181010a120",
    },
    4: {
      stakingDatabase: "0xD6Bd7690929610E63e1F53f89A6dBddAb79AE9fE",
      token: "0x4e0Fe270B856EeBb91Fb4B4364312be59F499A3F",
      distPool: "0x1017F01Ec5D7fC9CeCBf6083f1722EE8C967ee06",
    },
  },
  pgen: {
    2: {
      stakingDatabase: "",
      token: "",
      distPool: "",
    },
    3: {
      stakingDatabase: "0x5e80F3E01b3A5e61E481F9b81E17FA697727C757",
      token: "0x01d35cbC2070a3B76693Ce2b6364Eae24eb88591",
      distPool: "0x48A20c67b376B2de84F26901793Af1C6Cc9E2bEF",
    },
    4: {
      stakingDatabase: "",
      token: "",
      distPool: "",
    },
  },

  poli: {
    2: {
      stakingDatabase: "0x54CB8e9d82E59c505E0e001Bc599388a0019FC3C",
      token: "0xa1a36d3537bbe375cc9694795f663ddc8d516db9",
      distPool: "0xfc7a7ad217627545027b71e279e6fa36619690c4",
    },
    3: {
      stakingDatabase: "0xc68350d6bC933A5aa50eb50e95611B551B1783F6",
      token: "0x6fb54ffe60386ac33b722be13d2549dd87bf63af",
      distPool: "0xa24EfD1FA394cD6972b4451DDB7eAE013170B997",
    },
    4: {
      stakingDatabase: "",
      token: "",
      distPool: "",
    },
  },

  mimir: {
    2: {
      stakingDatabase: "0xd2e352735540e3af4B1b4AED3F00df45b62f0Eb8",
      token: "0x71dc40668682a124231301414167e4cf7f55383c",
      distPool: "0xCCc3e29aC708A35fCAF98421dd06739791ddFc52",
    },
    3: {
      stakingDatabase: "0xFfd1cD8f989F7563363AeE8D32902c16c7DDa01D",
      token: "0xd1790c5435b9fb7c9444c749cefe53d40d751eac",
      distPool: "0xECa5C09778deB93Cf65494d95a5ECd8e62927BB8",
    },
    4: {
      stakingDatabase: "0x3B5EA4aa9ff718441f469f0b84AdC804eAB273DF",
      token: "0x336f5a68fd46a25056a6c1d9c06072c691486acc",
      distPool: "0x6eC19A420Cc1f647B73244AD7405845b6eA07f1F",
    },
  },

  nitro: {
    2: {
      stakingDatabase: "0xDd0fE322E6f402642Afd951064c3a592b6c31993",
      token: "0x0335A7610D817aeCA1bEBbEfbd392ecC2eD587B8",
      distPool: "0x4C1ccd48573124E58E32b7cfEf3bAd83Dc551510",
    },
    3: {
      stakingDatabase: "0x229A79c7a77cF342a0C7cc8158D9f00a41Df24dD",
      token: "0x695FC8B80F344411F34bDbCb4E621aA69AdA384b",
      distPool: "0x4fA9FD470C222441F9D0aD7d5Af493e95F9314A1",
    },
    4: {
      stakingDatabase: "",
      token: "",
      distPool: "",
    },
  },

  quidd: {
    2: {
      stakingDatabase: "",
      token: "",
      distPool: "",
    },
    3: {
      stakingDatabase: "",
      token: "",
      distPool: "",
    },
    4: {
      stakingDatabase: "0xE31015F60fD4797Cd221999e484763A238dCbCe2",
      token: "0x7961ade0a767c0e5b67dd1a1f78ba44f727642ed",
      distPool: "0x62b6baaECBF38f5d4647e477CD723AE35AD91DB4",
    },
  },
};

export const networkProviders = {
  2: "https://mainnet.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161",
  100: "https://rinkeby.infura.io/v3/84842078b09946638c03157f83405213",
  97: "https://data-seed-prebsc-2-s1.binance.org:8545/",
  4: "https://bsc-dataseed.binance.org/",
  42: "https://kovan.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161",
  3: "https://polygon-rpc.com",
  80001: "https://rpc-mumbai.maticvigil.com/",
};

export const CHAIN_BY_NETWORK = {
  2: "Ethereum",
  3: "Polygon",
  4: "Binance",
};

export const STAKING_ADDRESS_MUMBAI =
  "0xdcd4Ad0df8bDFD442d0cd248df0DcC8c07E78889";

// export const STAKING_ADDRESS_RINKEBY =
//   "0xf14dF92B149Ba7a51ddE00baBdaeFb105FCd88dA";

export const STAKING_ADDRESS_RINKEBY =
  "0xC2703771633711ce1cEB4E26c9156DB73ABEaBB5";
// "0xC0fFE633CfF71EDE95383f539B1C6105cdCcCFd7"
// "0x7fAd81d31958af935aDF7C21d452cF315E07C2F0";

export const ZERO_ADDRESS = "0x0000000000000000000000000000000000000000";

export const BATCH_TRANSFER_ADDRESS_GOERLI =
  "0x34fd35C8f00092167BE2aCD20Ae3b128523ed070";

export const STAKING_ADDRESS_GEORLI =
  "0x653b1f010815caD8A158c4dA7DCf29361a2AA041";
// "0x179d326A6Ea1521987c19Ae57C136Fc1662A9d74";
// "0xd0175068735aB0D21a9c545f23543E6750C257B8";
// "0x1dd5b3951ce13de0cddccda285a5d8c841819c49";
// "0x24e280e68cD4a7B5222716AdcF782148124223DE";
// "0x44427D59de781D432DfdD88c6542557eaB349Fe5"; // guild hub updated
// "0x524015d69Ad71237c4742d3BE3f26AD065Ae395f"; // guild hub 1st
// "0xBb966E9e0658429fe79BE5d909Aa069daF44aad8"; //mavia latest
// "0x122fFB3d8b1878f2360D918c4C78Dfbe3f63de45"; //aroon latest
// "0xa059887B41E8627a68aa63e82224c279b07F003A";
// "0x14147b1B2315Dc6163805edA696e0E882f3bF26C";
// "0x249CDbA81193d9B6053D107Ca50B82d27AccC253";

export const STAKING_ADDRESS_MAINNET =
  "0x6396207236D715010bA03E756Bc3ADBe396fd174";

export const STAKING_ADDRESS_ETH = "0x56F18Fa143761610A6AC316D9f3F6bBA430F36a6";

export const ADAPTER_ADDRESS_RINKEBY =
  "0x31c414774A21608f4cB1fBedFB9D394579DeD288";

export const ADAPTER_ADDRESS_MAINNET =
  "0x56F18Fa143761610A6AC316D9f3F6bBA430F36a6";

export const ADAPTER_ADDRESS_ETH = "0x695fEd73E659bDB8E9573b82826A3b3bE675ba45";

export const NFT_1_ADDRESS_RINKEBY =
  "0x2CE6fBCe2D940725AF795Bf843f3D08d38801471";

export const NFT_2_ADDRESS_RINKEBY =
  "0x395b338bfA1D30A40Dedf4719d5437c0d9aDa347";

export const RINKEBY_SCAN_API = "https://api-rinkeby.etherscan.io/api";

export const ETHERSCAN_API_KEY = "3SAJ8EXQMXKXDFZPW14S2XVFKPIGZ6JMW2";

export const FETCH_ALL_USERS = `{
  users{
    id
    lentNfts {
      id
    }
    rentedNfts {
      id
    }
    encryptedKey
    isVerified
  }
}`;

export const FETCH_MARKET_NFT_QUERY = (address) => {
  return `{
    lends(where: {lender_not_ends_with : "${address.toLowerCase()}", isUnlend: false}) {
      id
      lender{id}
      nftAddress
      tokenId
      lendingId
      lentAt
      lendAmount
      borrower
      rewardTokenAddress
      isUnlend
      }
    }`;
};

export const FETCH_ALL_USER_LENDED_NFTS_QUERY = (address) => {
  return `{
    lends(where: {lender : "${address.toLowerCase()}", isUnlend: false}) {
      id
lender{id}
nftAddress
tokenId
lendingId
lentAt
lendAmount
borrower
rewardTokenAddress
isUnlend
      }
    }`;
};

export const FETCH_ALL_USER_DIRECT_LENDED_NFTS_QUERY = (address) => {
  return `{
    lends(where: {lender : "${address.toLowerCase()}", isUnlend: false, borrower_not_contains: "${ZERO_ADDRESS}"}) {
      id
lender{id}
nftAddress
tokenId
lendingId
lentAt
lendAmount
borrower
rewardTokenAddress
isUnlend
      }
    }`;
};

export const FETCH_ALL_LENDED_NFT_QUERY = (address) => {
  return `{
    lends(where: {lender : "${address.toLowerCase()}", isUnlend: false}) {
      id
lender{id}
nftAddress
tokenId
lendingId
lentAt
lendAmount
borrower
rewardTokenAddress
isUnlend
      }
    }`;
};

export const FETCH_ALL_RENTED_NFTS_QUERY = `
{
  rents{
    id
    lendAmount
    lendingId
    nftAddress
    rentedAt
    renter {
      id
    }
    split
    tokenId
  }
}
`;

export const FETCH_USER_RENTED_NFTS_QUERY = (address) => {
  return `{
  rents (where: { renter: "${address.toLowerCase()}" }) {
    id
  renter {id}
  nftAddress
  lendingId
  rentDuration
  rentedAt
  tokenId
  type
  amountPaid
  duration
  rentedTillTimestamp
  lendAmount
  }
  }  
`;
};

export const FETCH_CLAIMABLE_NFTS = (address) => {
  return `{
    lends (where: {isUnlend: false, borrower: "${address.toLowerCase()}"}){
      id
    lender{id}
    nftAddress
    tokenId
    lendingId
    lentAt
    lendAmount
    split
    borrower
    isUnlend
    rewardTokenAddress
    }
    }`;
};

export const FETCH_BORROWED_NFTS = (address) => {
  return `{
    rents(where: {renter: "${address.toLowerCase()}"}){
      id
      lendAmount
      lendingId
      nftAddress
      rentedAt
      renter {
        id
      }
      split
      tokenId
    }
  }`;
};

export const FETCH_LENDING_NFTS_FOR_SPECIFIC_SCHOLAR = (address) => {
  return `{
    lends(where: {borrower:"${address.toLowerCase()}", isUnlend: false}) {
      lendingId
      lender {
        id
      }
      borrower
      rewardTokenAddress
    }
  }`;
};
